import { defaultArtist } from "@/constants/defaultValues";
import { useNamedStore } from "@/lib/zustand/useNamedStore";
import { useNamedPitchCorrection } from "@/lib/zustand/usePitchCorrection";
import { ModelPitchRange } from "@/types/defs/modelPitchRange";
import { Artist } from "@/types/types";

type State = {
  selectedArtistId: Artist["id"];
  setSelectedArtistId: (artist: Artist["id"]) => void;
  // The selected voice's pitch range, resolved by the React layer (which holds the server-fetched models) and read by the non-React audio-quality check.
  selectedModelPitchRange: ModelPitchRange;
  setSelectedModelPitchRange: (pitchRange: ModelPitchRange) => void;
};

export const useNamedSelectedArtist = useNamedStore<State>(
  (key: string) => (set) => ({
    selectedArtistId: defaultArtist.id,
    setSelectedArtistId: (artistId) => {
      set({ selectedArtistId: artistId });
      useNamedPitchCorrection
        .getState()
        .getNamedStore(key)
        .getState()
        .unsetDecodedAudioDataUrl();
    },
    selectedModelPitchRange: null,
    setSelectedModelPitchRange: (pitchRange: ModelPitchRange) =>
      set({ selectedModelPitchRange: pitchRange }),
  })
);
